import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { freeMaterialsTabsData } from "../../../data/SidebarData";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";
import useSWR from "swr";
import { MaterialApiUrls } from "../../../Api/Auth/ApiUrls";

const FeMaterial = () => {
  const { data } = useSWR(MaterialApiUrls.list(""));

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={freeMaterialsTabsData} />
      <StaticPageForm
        title="Free FE Materials"
        typeData={data}
        type="materials"
        category={"civil"}
      />
    </div>
  );
};

export default FeMaterial;
